import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'
import { LocalizedLink } from '@/components/LocalizedLink'
import type { SupportedLanguage } from '@/i18n'

const COOKIE_KEY = 'selea_cookie_consent'

export function CookieBanner() {
  const { t, i18n } = useTranslation()
  const lang = (i18n.language || 'it') as SupportedLanguage
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY)
    if (!consent) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted')
    setVisible(false)
  }

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined')
    setVisible(false)
  }

  const cookieSlug = lang === 'en' ? 'cookie-policy' : 'cookie-policy'

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-4 left-4 z-modal bg-white border border-surface-border rounded-xl shadow-lg p-5 max-w-sm"
        >
          <div className="flex flex-col gap-4">
            <p className="text-sm text-text-body leading-relaxed">
              {t('cookie.message')}{' '}
              <LocalizedLink
                to={`/${cookieSlug}`}
                className="text-accent hover:underline font-medium"
              >
                {t('cookie.learnMore')}
              </LocalizedLink>
            </p>
            <div className="flex gap-3">
              <button
                onClick={handleDecline}
                className="px-4 py-2 text-sm font-medium text-text-muted hover:text-text-body transition-colors"
              >
                {t('buttons.decline')}
              </button>
              <button
                onClick={handleAccept}
                className="btn-primary text-sm px-4 py-2"
              >
                {t('buttons.accept')}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
